import { ReactNode } from "react"
import { Container, Spinner } from "reactstrap"
import Breadcrumb from "Components/organisms/breadcrumb"
import Tabs from "Components/molecule/tabs"
import HrViewContent from "Components/organisms/hr-dashboard/hr-view-content"
import { HrGroupBy, HrView } from "models/hr-dashboard"
import { HrDashboardViews } from "slices/human-resources/hr-dashboard/reducer"

// Tab label for each view, in display order
export const HR_DASHBOARD_TABS: Record<HrView, string> = {
    "headcount": "Employee Headcount",
    "by-group": "Headcount by Department",
    "consultants": "Consultants",
    "compare": "Employees vs Consultants",
    "movement": "All Movement",
    "turnover": "Employee Turnover",
    "retention": "Retention",
}

export const viewFromTab = (tab: string): HrView =>
    (Object.keys(HR_DASHBOARD_TABS) as HrView[]).find(v => HR_DASHBOARD_TABS[v] === tab) ?? "headcount"

interface HRDashboardTemplateProps {
    views: HrDashboardViews
    groupBy: HrGroupBy
    setGroupBy: (groupBy: HrGroupBy) => void
    isLoading: boolean
    activeTab: string
    setActiveTab: React.Dispatch<React.SetStateAction<string>>
    actions?: ReactNode
    modal?: ReactNode
}

const HRDashboardTemplate = ({ views, groupBy, setGroupBy, isLoading, activeTab, setActiveTab, actions, modal }: HRDashboardTemplateProps) => {
    const activeView = viewFromTab(activeTab)

    return <div className="page-content">
        <Container fluid style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <Breadcrumb
                title="Human Resources"
                breadcrumbItem="HR Dashboard"
                actions={actions}
            />
            <div className="section-container">
                <Tabs
                    headers={Object.values(HR_DASHBOARD_TABS)}
                    tabs={{
                        [activeTab]: isLoading
                            ? <div className="text-center my-5"><Spinner /></div>
                            : <HrViewContent view={activeView} views={views} groupBy={groupBy} setGroupBy={setGroupBy} />,
                    }}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                />
            </div>
            {modal}
        </Container>
    </div>
}

export default HRDashboardTemplate
